function pluralFilter() {
    return (value: string): string => `${value}s`;
}

export default {
    name: 'pluralFilter',
    definition: pluralFilter
};
